/* eslint-disable no-confusing-arrow */
import * as yup from 'yup';

const validationSchema = yup.object().shape({
  approvers: yup
    .array()
    .of(
      yup.object().shape({
        delegateApprover: yup
          .object()
          .shape({
            value: yup.number().required(),
            label: yup.string(),
          })
          .required('Approver is required.'),

        approvalType: yup
          .string()
          .required('Approval Type is required.')
          .when('delegateApprover', {
            is: val => !!val,
            then: schema => schema.required('Approval Type is required.'),
            otherwise: schema => schema.optional(),
          }),

        isActive: yup
          .string()
          .required('Status is required.')
          .when('delegateApprover', {
            is: val => !!val,
            then: schema => schema.required('Status is required.'),
            otherwise: schema => schema.optional(),
          }),

        fromDate: yup
          .date()
          .required('From Date is required.')
          .transform((value, originalValue) =>
            originalValue === '' ? null : value,
          )
          .when('delegateApprover', {
            is: val => !!val,
            then: schema => schema.required('From Date is required.'),
            otherwise: schema => schema.optional(),
          }),

        toDate: yup
          .date()
          .required('To Date is required.')
          .transform((value, originalValue) =>
            originalValue === '' ? null : value,
          )
          .when('delegateApprover', {
            is: val => !!val,
            then: schema =>
              schema
                .required('To Date is required.')
                .typeError('To Date is invalid.')
                .test(
                  'is-after-start',
                  'To Date must be on or after From Date.',
                  function (toDate) {
                    const { fromDate } = this.parent;
                    if (!fromDate || !toDate) return true;
                    return new Date(toDate) >= new Date(fromDate);
                  },
                ),
            otherwise: schema => schema.optional(),
          }),
      }),
    )
    .test(
      'unique-approvalType',
      'Each Approval Type must be unique.',
      approvers => {
        if (!approvers) return true;

        const seen = new Set();
        const hasDuplicates = approvers.some(approver => {
          if (approver.delegateApprover && approver.approvalType) {
            const key = approver.approvalType;
            if (seen.has(key)) {
              return true;
            }
            seen.add(key);
          }
          return false;
        });
        return !hasDuplicates;
      },
    ),
});

export default validationSchema;
